import 'dotenv/config';
import * as css from "./Contact.module.scss";

export function Contact({scrollRef}) {
    const profilePicUrl = new URL("../../images/christopher-rowden.png", import.meta.url);
    const emailAdress = process.env.ENKINDLE_EMAIL_ADDRESS_LINK;
    const phoneNumberLink = process.env.ENKINDLE_PHONE_NUMBER_LINK;
    
    return (
        <div ref={scrollRef} className={css.contactBox}>
            <div className={css.contact}>
                <div className={css.contactPhotoBox}>
                    <img src={profilePicUrl} alt="Christopher Rowden, creator of Enkinkdle" />
                    <h2 className={css.contactPhotoBoxName}>Christopher Rowden</h2>
                    <p className={css.contactPhotoBoxTitle}>Music Missionary</p>
                    <div className={css.contactCtaBox}>
                        <a className={css.contactCtaLink} href={`mailto:${emailAdress}`}>Email Me</a>
                        <a className={css.contactCtaLink} href={`tel:${phoneNumberLink}`}>Call Me</a>
                    </div>
                </div>
                {/* <p className={css.contactMessageBox}>I felt called to create Enkindle out of a desire to connect people to the power and mystery of the Kerygma. I've had this experience, and it changed my life! Now, I want to share it with you.</p> */}
            </div>
        </div>
    );
}